import { getFilestackImageSizeFromRatio } from './getFilestackImageSizeFromRatio';

const MAX_FILESTACK_SIZE = 10000;

type Args = {
  originalSize: { width: number; height: number } | undefined;
  size: { width?: number; height?: number };
};

export function getFilestackImageSize({ originalSize, size }: Args): {
  width: number | undefined;
  height: number | undefined;
} {
  if (typeof size.width === 'number' && typeof size.height === 'number') {
    return { width: size.width, height: size.height };
  }

  if (!originalSize) return { width: size.width, height: size.height };

  const calculatedSize = getFilestackImageSizeFromRatio({ originalSize, size });

  const maxWidth = Math.min(
    calculatedSize.width,
    originalSize.width,
    MAX_FILESTACK_SIZE,
  );

  const maxHeight = Math.min(
    calculatedSize.height,
    originalSize.height,
    MAX_FILESTACK_SIZE,
  );

  const widthScaleDownFactor = maxWidth / calculatedSize.width;
  const heightScaleDownFactor = maxHeight / calculatedSize.height;

  const scaleDownFactor = Math.min(widthScaleDownFactor, heightScaleDownFactor);

  const width = Math.floor(calculatedSize.width * scaleDownFactor);
  const height = Math.floor(calculatedSize.height * scaleDownFactor);

  return { width, height };
}
